import React, { Component } from 'react';
import PropTypes from 'prop-types';
import * as THREE from 'three';
import ReactDOM from 'react-dom';
import { Canvas } from './styles';
import UpdateLoop from '../../utils/UpdateLoop';

class Renderer extends Component {
	constructor(props) {
		super(props);
		this.children = [];
	}

	componentDidMount() {
		this.create();
	}

	componentWillUnmount() {
		this.destroy();
	}

	create = () => {
		const { width, height } = this.props;

		this.canvas = ReactDOM.findDOMNode(this);

		// Renderer
		this.renderer = new THREE.WebGLRenderer({ alpha: false, antialias: false, canvas: this.canvas });
		this.renderer.setClearColor(this.props.backgroundColor);
		this.renderer.shadowMap.enabled = true;
		this.renderer.setPixelRatio(window.devicePixelRatio);
		this.renderer.setSize(width, height);

		// Scene
		this.scene = new THREE.Scene();

		this.props.children.forEach(child => this.scene.add(child));

		// Camera
		this.camera = new THREE.PerspectiveCamera(42, width / height, 0.25, 10000);
		this.camera.position.set(0, 0, 6.2);
		this.camera.rotation.set(0, 0, 0);

		UpdateLoop.add(this);
		UpdateLoop.start();
	};

	destroy = () => UpdateLoop.remove(this);

	update = delta => {
		this.renderer.render(this.scene, this.camera);
	};

	render() {
		this.children.forEach(child => this.scene.remove(child));
		this.props.children.forEach(child => this.scene && this.scene.add(child));
		this.children = this.props.children;
		return <Canvas />;
	}
}

Renderer.propTypes = {
	width: PropTypes.number.isRequired,
	height: PropTypes.number.isRequired,
	backgroundColor: PropTypes.number,
};

Renderer.defaultProps = {
	backgroundColor: 0xfcfcf2,
	children: [],
};

export default Renderer;



// WEBPACK FOOTER //
// ./src/components/Renderer/index.js